<script lang="ts" context="module">
    
    import type { User } from "../Model/User";

    const usersCache = new Map<string, Promise<User>>();

</script>

<script lang="ts">

    import { usersService } from "../Services";

    export let id: string;

    let userName = '';

    $: getUserName(id);

    async function getUserName(userId: string): Promise<void> {
        try {
            if (!usersCache.has(userId)) {
                usersCache.set(userId, usersService.getUser(userId));
            }
            const user = await usersCache.get(userId)!;
            userName = user.name;
        } catch (error) {
            console.error(error);
        }
    }

</script>

{userName}